const orderArrayByAttribute = (array, attribute) => {
  array.sort((a, b) => (a[`${attribute}`] > b[`${attribute}`]) ? 1 : -1)

  return array
}
export default orderArrayByAttribute



// WEBPACK FOOTER //
// ./src/helpers/orderArrayByAttribute.js